var $9b0863f15a26a58c$exports = {};
$9b0863f15a26a58c$exports = {
    "close": `\u{95DC}\u{9589}`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} \u{500B}\u{901A}\u{77E5}`,
            other: ()=>`${formatter.number(args.count)} \u{500B}\u{901A}\u{77E5}`
        })}\u{3002}`
};


export {$9b0863f15a26a58c$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
